import { sendEmailEmployee } from "../../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useSendEmail = () => {
  return useMutation(sendEmailEmployee);
};
export default useSendEmail;
